import React from 'react';
import { Icon } from 'elements';

const ArrowRight = ({size, className}) => (
  <Icon size={size} className={className}>
    <polygon points="6,4.12 13.802,12 6,19.88 8.099,22 18,12 8.099,2 "/>
  </Icon>
);

export default ArrowRight;



// WEBPACK FOOTER //
// ./src/core/icons/components/ArrowRight.jsx